/* Viktor Header — BrickHouse dev theme. Vanilla, no deps.
   Panels: menu drawer + search overlay only. Cart is the theme's NATIVE
   cart (link + aria-controls="cart-drawer"); we do not touch cart/checkout. */
(function () {
  "use strict";
  var root = document.getElementById("vh-root");
  if (!root) return;

  var backdrop = root.querySelector("[data-vh-backdrop]");
  var panels = {};
  root.querySelectorAll("[data-vh-panel]").forEach(function (p) {
    panels[p.getAttribute("data-vh-panel")] = p;
  });
  var open = null;

  function lock(on) { document.body.classList.toggle("vh-locked", on); }

  function show(name) {
    if (open === name) return close();
    if (open) hidePanel(open);
    var p = panels[name];
    if (!p) return;
    p.hidden = false;
    backdrop.hidden = false;
    void p.offsetWidth; // reflow so the transition runs
    requestAnimationFrame(function () {
      p.classList.add("is-open");
      backdrop.classList.add("is-open");
    });
    open = name;
    lock(true);
    if (name === "search") {
      var inp = p.querySelector("[data-vh-search-input]");
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    }
  }

  function hidePanel(name) {
    var p = panels[name];
    if (!p) return;
    p.classList.remove("is-open");
    setTimeout(function () { p.hidden = true; }, 300);
  }

  function close() {
    if (!open) return;
    hidePanel(open);
    backdrop.classList.remove("is-open");
    setTimeout(function () { backdrop.hidden = true; }, 300);
    open = null;
    lock(false);
  }

  root.querySelectorAll("[data-vh-open]").forEach(function (b) {
    b.addEventListener("click", function () { show(b.getAttribute("data-vh-open")); });
  });
  root.querySelectorAll("[data-vh-close]").forEach(function (b) {
    b.addEventListener("click", close);
  });
  backdrop.addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  /* ---------------- Predictive search ---------------- */
  var searchInput = root.querySelector("[data-vh-search-input]");
  var predict = root.querySelector("[data-vh-predict]");
  var tmr;
  if (searchInput && predict) {
    searchInput.addEventListener("input", function () {
      clearTimeout(tmr);
      var q = searchInput.value.trim();
      if (q.length < 2) { predict.innerHTML = ""; return; }
      tmr = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
              "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last",
              { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { predict.innerHTML = ""; return; }
            var html = '<div class="vh-predict">';
            items.forEach(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || "");
              html += '<a href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="vh-predict__img"></span>') +
                '<span class="vh-predict__name">' + p.title + "</span></a>";
            });
            html += "</div>";
            predict.innerHTML = html;
          })
          .catch(function () { predict.innerHTML = ""; });
      }, 180);
    });
  }
})();

/* ---------------- Goal bar: mobile scroll edge-fade ----------------
   Sets data-vh-edge on .vh-catbar so CSS shows a fade on whichever side has
   more off-screen tabs. Signals horizontal scroll before the user touches,
   and hides at each end. Passive + rAF-throttled; no-ops where the bar fits. */
(function () {
  "use strict";
  var bar = document.querySelector(".vh-catbar");
  if (!bar) return;
  var sc = bar.querySelector(".vh-catbar__scroll");
  if (!sc) return;
  var raf = 0;
  function update() {
    raf = 0;
    var max = sc.scrollWidth - sc.clientWidth;
    if (max <= 2) { bar.setAttribute("data-vh-edge", "none"); return; }
    var x = sc.scrollLeft;
    bar.setAttribute("data-vh-edge", x <= 1 ? "start" : (x >= max - 1 ? "end" : "mid"));
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
  function centerActive() {
    var active = sc.querySelector('[aria-current="page"]');
    if (!active) return;
    var want = active.offsetLeft - (sc.clientWidth - active.clientWidth) / 2;
    sc.scrollLeft = Math.max(0, want);
  }
  sc.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () { centerActive(); onScroll(); }, { passive: true });
  centerActive();
  update();

  /* Sticky strip: where the goal bar exists (home + collection pages), let the logo
     header scroll away and pin the slim category strip to the top of the viewport.
     position:sticky can't carry past the bar's short section wrapper, so we toggle
     position:fixed with a same-height spacer (prevents content jump) once the bar
     reaches the top. */
  /* Static bars (e.g. the bundle page shop bar) must NOT pin: the fixed-toggle +
     spacer shifts layout while the Recharge bundle widget measures collection
     heights, collapsing it. Skip all sticky-pin behavior for them. */
  if (bar.classList.contains("vh-catbar--static")) return;

  var stickyHeader = document.querySelector(".vh-sticky");
  if (stickyHeader) stickyHeader.classList.add("vh-sticky--release");

  var spacer = document.createElement("div");
  spacer.setAttribute("aria-hidden", "true");
  spacer.style.display = "none";
  bar.parentNode.insertBefore(spacer, bar);
  var pinned = false;
  function startTop() {
    return (pinned ? spacer : bar).getBoundingClientRect().top + window.pageYOffset;
  }
  var anchor = startTop();
  function onPinScroll() {
    var y = window.pageYOffset;
    if (!pinned && y >= anchor) {
      spacer.style.height = bar.offsetHeight + "px";
      spacer.style.display = "block";
      bar.classList.add("vh-catbar--fixed");
      pinned = true;
    } else if (pinned && y < anchor) {
      bar.classList.remove("vh-catbar--fixed");
      spacer.style.display = "none";
      pinned = false;
    }
  }
  window.addEventListener("scroll", onPinScroll, { passive: true });
  window.addEventListener("resize", function () {
    if (pinned) { bar.classList.remove("vh-catbar--fixed"); spacer.style.display = "none"; pinned = false; }
    anchor = startTop();
    onPinScroll();
  }, { passive: true });
  onPinScroll();
})();
